// @mui
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { RoleEnum } from '../../enums/role';
import SuperAdminNavbar from './NavSectionRole/superAdmin';
import AdminNavbar from './NavSectionRole/admin';
import HrNavbar from './NavSectionRole/HR';

// ----------------------------------------------------------------------

export default function NavSection({ data = [], ...other }: any) {
  const authData = useSelector((state: RootState) => state?.auth?.data);

  return (
    <Box {...other}>
      <Box sx={{ height: 'calc(100vh - 180px)', overflow: 'auto' }}>
        {/* <List disablePadding sx={{ p: 1, paddingBottom: 10 }}>
          <Typography sx={{ mb: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.GENERAL")}</Typography>
          {
            checkPermission(authData?.role?.role_type ?? "", HOME_ROUTE)
            &&
            <NavItem title={t("navbar.Dashboard")} path={HOME_ROUTE} icon={<IconImage imageUrl={DASHBOARD_ICON} />} />
          }
          {
            checkPermission(authData?.role?.role_type ?? "", ORDER_ROUTE)
            &&
            <NavItem title={t("navbar.Order Management")} path={ORDER_ROUTE} icon={<IconImage imageUrl={order_ic} />} />

          }

          <Typography sx={{ mb: 2, mt: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.REPORT")}</Typography>
          {
            checkPermission(authData?.role?.role_type ?? "", SALES_REPORT_ROUTE)
            &&
            <NavItem title={t("navbar.All Report")} path={SALES_REPORT_ROUTE} icon={<IconImage imageUrl={report_ic} />} />

          }
          {
            checkPermission(authData?.role?.role_type ?? "", RIDER_REPORT)
            &&
            <NavItem title={t("navbar.Rider Report")} path={RIDER_REPORT} icon={<IconImage imageUrl={driver_ic} />} />

          }
          {
            checkPermission(authData?.role?.role_type ?? "", COUPON_HISTORY)
            &&
            <NavItem title={t("navbar.Coupon Report")} path={COUPON_HISTORY} icon={<IconImage imageUrl={coupon_ic} />} />
          }




          <Typography sx={{ mb: 2, mt: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.MANAGEMENT")}</Typography>
          {
            checkPermission(authData?.role?.role_type ?? "", CUSTOMER_ROUTE)
            &&
            <NavItem title={t("navbar.Customer")} path={CUSTOMER_ROUTE} icon={<IconImage imageUrl={customer_ic} />} />
          }
          {
            checkPermission(authData?.role?.role_type ?? "", HR_MANAGE)
            &&
            <NavItem title={t("navbar.HR manage")} path={HR_MANAGE} icon={<IconImage imageUrl={customer_ic} />} />
          }
          {
            checkPermission(authData?.role?.role_type ?? "", ADMIN_ACCOUNT_ROUTE)
            &&
            <NavItem title={t("navbar.Admin Account")} path={ADMIN_ACCOUNT_ROUTE} icon={<IconImage imageUrl={admin_ic} />} />
          }
          {
            checkPermission(authData?.role?.role_type ?? "", MASTER_PRODUCT_ROUTE)
            &&
            <NavItem title={t("navbar.Master Product")} path={MASTER_PRODUCT_ROUTE} icon={<IconImage imageUrl={product_ic} />} />
          }
          {
            checkPermission(authData?.role?.role_type ?? "", MASTER_CATEGORY_ROUTE)
            &&
            <NavItem title={t("navbar.Master Category")} path={MASTER_CATEGORY_ROUTE} icon={<IconImage imageUrl={category_ic} />} />
          }

          <NestedListItem nestedValue={t("navbar.Merchant")} iconSrc={jiffy_merchant_ic} listItems={[

            <NavItem title={t("navbar.Merchant User")} path={STAFF_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
            <NavItem title={t("navbar.Branch")} path={BRANCH_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
            <NavItem title={t("navbar.Product Merchant")} path={PRODUCT_MERCHANT_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
            <NavItem title={t("navbar.Category Merchant")} path={CATEGORY_MERCHANT_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,

          ].filter((item) => checkPermission(authData?.role?.role_type ?? "", item?.props?.path))} />

          <NestedListItem nestedValue={t('navbar.Driver')} iconSrc={driver_ic} listItems={[
            <NavItem title={t("navbar.All Driver")} path={DRIVER_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
            <NavItem title={t("navbar.Driver Form Register")} path={FORM_DRIVER_REGISTER} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
            // <NavItem title={"Driver bonus"} path={DRIVER_BONUS_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
          ].filter((item) => checkPermission(authData?.role?.role_type ?? "", item?.props?.path))} />



          <Typography sx={{ mb: 2, mt: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.ACCOUNTING")}</Typography>
          {
            checkPermission(authData?.role?.role_type ?? "", RIDER_BALANCE) &&
            <NavItem title={t("navbar.Clearance Money Rider")} path={RIDER_BALANCE} icon={<IconImage imageUrl={driver_ic} />} />
          }
          {
            checkPermission(authData?.role?.role_type ?? "", DRIVER_FINANCIAL_CLEARANCE_ROUTE) &&
            <NavItem title={t("navbar.Payment Money Rider")} path={DRIVER_FINANCIAL_CLEARANCE_ROUTE} icon={<IconImage imageUrl={driver_ic} />} />
          }



          <Typography sx={{ mb: 2, mt: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.MARKETING")}</Typography>
          {
            authData?.role?.role_type === RoleEnum.SUPER_ADMIN
            &&
            <NestedListItem nestedValue={t('navbar.Advertisement')} iconSrc={advertisement_ic} listItems={[
              <NavItem title={t("navbar.Popup")} path={POPUP_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
              <NavItem title={t("navbar.Banner")} path={BANNER_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
            ].filter((item) => checkPermission(authData?.role?.role_type ?? "", item?.props?.path))} />
          }
          {
            checkPermission(authData?.role?.role_type ?? "", PROMOTION_ROUTE)
            &&
            <NavItem title={t("navbar.Promotion")} path={PROMOTION_ROUTE} icon={<IconImage imageUrl={jiffy_merchant_ic} />} />
          }
          {
            checkPermission(authData?.role?.role_type ?? "", COUPON_ROUTE)
            &&
            <NavItem title={t("navbar.Coupon Management")} path={COUPON_ROUTE} icon={<IconImage imageUrl={coupon_ic} />} />
          }

          {
            checkPermission(authData?.role?.role_type ?? "", NOTIFICATION_ROUTE)
            &&
            <NavItem title={t("navbar.Notification")} path={NOTIFICATION_ROUTE} icon={<IconImage imageUrl={advertisement_ic} />} />
          }


          {
            authData?.role?.role_type === RoleEnum.SUPER_ADMIN
            &&
            <Typography sx={{ mb: 2, mt: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.SETTING")}</Typography>
          }
          {
            checkPermission(authData?.role?.role_type ?? "", CHANGE_MONEY_RIDER)
            &&
            <NavItem title={t("navbar.Multiplier Money")} path={CHANGE_MONEY_RIDER} icon={<IconImage imageUrl={order_ic} />} />
          }
          {
            checkPermission(authData?.role?.role_type ?? "", DELIVERY_FEE_MANAGEMENT_ROUTE)
            &&
            <NavItem title={t("navbar.Delivery Free management")} path={DELIVERY_FEE_MANAGEMENT_ROUTE} icon={<IconImage imageUrl={driver_ic} />} />
          }
        </List> */}
        {
          authData?.role?.role_type === RoleEnum.SUPER_ADMIN ? <SuperAdminNavbar /> : authData?.role?.role_type === RoleEnum.ADMIN ? <AdminNavbar /> : <HrNavbar />
        }
      </Box>
    </Box>
  );
}